/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Overlap_TitleInputs */

const en_subtitle_import_overlap_title = /** @type {(inputs: Subtitle_Import_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overlapping Events`)
};

const fr_subtitle_import_overlap_title = /** @type {(inputs: Subtitle_Import_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenements chevauchants`)
};

const de_subtitle_import_overlap_title = /** @type {(inputs: Subtitle_Import_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überlappende Ereignisse`)
};

const it_subtitle_import_overlap_title = /** @type {(inputs: Subtitle_Import_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi sovrapposti`)
};

const ru_subtitle_import_overlap_title = /** @type {(inputs: Subtitle_Import_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пересекающиеся события`)
};

const es_subtitle_import_overlap_title = /** @type {(inputs: Subtitle_Import_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos superpuestos`)
};

const zh_cn2_subtitle_import_overlap_title = /** @type {(inputs: Subtitle_Import_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重叠事件`)
};

const ja_subtitle_import_overlap_title = /** @type {(inputs: Subtitle_Import_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複するイベント`)
};

const hi_subtitle_import_overlap_title = /** @type {(inputs: Subtitle_Import_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अतिव्यापी घटनाएँ`)
};

const pt_pt2_subtitle_import_overlap_title = /** @type {(inputs: Subtitle_Import_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos sobrepostos`)
};

/**
* | output |
* | --- |
* | "Overlapping Events" |
*
* @param {Subtitle_Import_Overlap_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_overlap_title = /** @type {((inputs?: Subtitle_Import_Overlap_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Overlap_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_import_overlap_title(inputs)
	if (locale === "de") return de_subtitle_import_overlap_title(inputs)
	if (locale === "it") return it_subtitle_import_overlap_title(inputs)
	if (locale === "ru") return ru_subtitle_import_overlap_title(inputs)
	if (locale === "es") return es_subtitle_import_overlap_title(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_import_overlap_title(inputs)
	if (locale === "ja") return ja_subtitle_import_overlap_title(inputs)
	if (locale === "hi") return hi_subtitle_import_overlap_title(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_import_overlap_title(inputs)
	return en_subtitle_import_overlap_title(inputs)
});